import { useState } from "react";
import { useApolloClient, useLazyQuery, useMutation } from "@apollo/client";
import { Col, Row } from "reactstrap";
import { CREATE_CSO_WISH, DELETE_CSO_WISH } from "../../mutations";
import { GET_CSO_LIST, GET_CSO_WISH_DATA } from "../../queries";
import styles from "./index.module.scss";
import NewTabIcon from "./newtab.png";
import { Link } from "react-router-dom";
import DissolveBadge from "../../../../../components/DissolveBadge";
// import Star from "./star.png";

const CsoResult = ({
  cso = {},
  onCsoWishCreated,
  onCsoWishDeleted,
  canEdit = true,
}) => {
  const client = useApolloClient();
  const [wished, setWished] = useState(cso.isWished);
  const [createCsoWish, { data, loading: creatingCsoWish, error }] =
    useMutation(CREATE_CSO_WISH, {
      onCompleted: async (data) => {
        await client.refetchQueries({
          include: [GET_CSO_LIST],
        });
        onCsoWishCreated(data?.createCsoWish?.csoWish?.cso?.id);
      },
      errorPolicy: "ignore",
    });
  const [
    deleteCsoWish,
    { data: deleteData, error: deleteError, loading: deletingCsoWish },
  ] = useMutation(DELETE_CSO_WISH, {
    onCompleted: async (data) => {
      await client.refetchQueries({
        include: [GET_CSO_LIST],
      });
      onCsoWishDeleted(cso.id);
    },
    errorPolicy: "ignore",
  });

  const [
    getCsoData,
    { data: csoData, error: csoDataError, loading: gettingCsoData },
  ] = useLazyQuery(GET_CSO_WISH_DATA, {
    onCompleted: (data) => {
      const csoWish = data?.myCsoWishes?.edges?.[0]?.node;
      if (csoWish) {
        deleteCsoWish({
          variables: {
            csoWishId: csoWish.id,
          },
        });
      }
    },
    errorPolicy: "ignore",
  });

  const disableButton = creatingCsoWish || deletingCsoWish || gettingCsoData;
  return (
    <div
      style={{
        borderBottom: "1px solid #e0e0e0",
        marginBottom: "16px",
        paddingBottom: "8px",
        width: "100%",
      }}
    >
      <Row
        style={{
          marginBottom: "4px",
        }}
      >
        <Col
          xs={12}
          lg={8}
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          {cso.logoUrl && (
            <img
              alt={cso.name}
              src={cso.logoUrl}
              style={{
                width: "37px",
                height: "27px",
              }}
            />
          )}
          <p style={{ marginBottom: "0px", fontWeight: "bold" }}>
            {cso?.homepage ? (
              <Link
                to={`/dashboards/plofile-organization/${cso.pk}`}
                target="_blank"
                rel="noreferrer"
              >
                {cso.name}
              </Link>
            ) : (
              <span>{cso.name}</span>
            )}
          </p>
          <span
            style={{
              marginLeft: "8px",
              display: "flex",
              flexGrow: 1,
            }}
          >
            {cso.isDissolve && <DissolveBadge />}
          </span>
        </Col>
        <Col
          xs={12}
          lg={4}
          style={{
            textAlign: "right",
          }}
        >
          {canEdit && (
            <button
              className={
                wished
                  ? styles["register-button--registered"]
                  : styles["register-button"]
              }
              onClick={() => {
                if (disableButton) return;
                if (!cso.isWished) {
                  setWished(true);
                  createCsoWish({
                    variables: {
                      csoId: cso.id,
                    },
                  });
                } else {
                  setWished(false);
                  getCsoData({
                    variables: {
                      csoId: cso.id,
                    },
                  });
                }
              }}
              disabled={disableButton}
            >
              {wished ? "登録済み" : "登録する"}
            </button>
          )}
        </Col>
      </Row>
      {/* <Row>
        <Col xs={12}>
          {Array.from({ length: 5 }).map((_, i) => {
            return <img alt="" src={Star} />;
          })}
        </Col>
      </Row> */}
      {/* <Row>
        <Col
          xs={12}
          style={{ display: "flex", marginBottom: "2px", marginTop: "2px" }}
        >
          {Array.from({ length: 17 }).map((_, i) => {
            return (
              <div
                style={{
                  fontSize: "10px",
                  width: "14px",
                  height: "14px",
                  backgroundColor: "#D9D9D9",
                  marginRight: "2px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "50%",
                }}
              >
                {i}
              </div>
            );
          })}
        </Col>
      </Row> */}
      <Row>
        <Col xs={12}>
          <div
            style={{
              fontSize: "13px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "-webkit-box",
              WebkitLineClamp: 4, // Limit to 4 lines
              WebkitBoxOrient: "vertical",
              whiteSpace: "normal",
            }}
          >
            {cso.purpose}
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default CsoResult;
